<div class="mb-3">
  <div class="section-banner">
    <i class="bx bx-error-alt"></i>
    <span>Alergias e Intolerancias ({{ allergies().length }})</span>
  </div>
  <div class="section-banner-body">
    @for (allergy of allergies(); track allergy.id; let idx = $index) {
      @let clinicalCoding = allergy.clinicalStatus?.coding?.[0];
      @let estadoBadge = getEstadoBadge(clinicalCoding?.display || clinicalCoding?.code || '');
      @let tipoBadge = getTipoBadge(allergy.type || '');

      <div class="d-flex align-items-center justify-content-between mb-3">
        <div class="d-flex align-items-center gap-2">
          <span
            class="badge bg-secondary rounded-circle"
            style="
              width: 32px;
              height: 32px;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            #{{ idx + 1 }}
          </span>
          <strong>{{
            allergy.code?.text || allergy.code?.coding?.[0]?.display || 'Sin descripción'
          }}</strong>
        </div>
        @if (clinicalCoding) {
          <span class="badge {{ estadoBadge.color }} px-3 py-2">
            {{ estadoBadge.label }}
          </span>
        }
      </div>

      <div class="row g-2">
        <div class="col-md-6">
          @if (allergy.type) {
            <p class="mb-2"><strong>Tipo de Alergia:</strong> {{ tipoBadge.label }}</p>
          }
          @if (allergy.code?.text) {
            <p class="mb-2"><strong>Descripción:</strong> {{ allergy.code!.text }}</p>
          }
        </div>
        <div class="col-md-6">
          @if (allergy.recordedDate) {
            <p class="mb-2">
              <strong>Fecha de Registro:</strong> {{ allergy.recordedDate.substring(0, 10) }}
            </p>
          }
        </div>
      </div>

      @if (!$last) {
        <hr />
      }
    }
  </div>
</div>
<hr />
